/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


(() => {
  function setupCategoryButtons() {
    document.querySelectorAll('.slideshow__button[href="#mobile-menu"]').forEach(link => {
      const slideshow = link.closest('.slideshow');
      const toggle = document.querySelector('.header__mobile-nav-toggle[aria-controls="mobile-menu"]');
      if (!slideshow || !toggle) return;
      const row = document.createElement('div');
      row.className = 'catalogue-menu-action';
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'button button--primary';
      button.textContent = link.textContent;
      button.setAttribute('aria-controls', 'mobile-menu');
      button.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded'));
      button.addEventListener('click', event => {
        event.stopPropagation();
        toggle.scrollIntoView({block: 'center'});
        if (toggle.getAttribute('aria-expanded') !== 'true') toggle.click();
        toggle.focus({preventScroll:true});
      });
      new MutationObserver(() => button.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded'))).observe(toggle, {attributes: true, attributeFilter: ['aria-expanded']});
      row.append(button);
      slideshow.after(row);
      link.remove();
    });
  }
  const style = document.createElement('style');
  style.textContent = '.catalogue-menu-action{text-align:center;padding:16px 20px 0}.catalogue-menu-action .button{margin:0;min-height:44px;background:#1e2d7d;color:#fff}@media(min-width:1000px){.catalogue-menu-action{display:none}}';
  document.head.append(style);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupCategoryButtons);
  else setupCategoryButtons();
  document.addEventListener('shopify:section:load', setupCategoryButtons);
})();

(() => {
  document.addEventListener('click', event => {
    const browse = event.target.closest('[data-browse-children]');
    if (browse) {
      const mobileToggle = document.querySelector('.header__mobile-nav-toggle[aria-controls="mobile-menu"]');
      const mobileChild = document.querySelector('.mobile-menu__nav-link[aria-controls="mobile-panel-3"]');
      const desktopChild = document.querySelector('.nav-bar__link[aria-controls="desktop-menu-0-4"]');
      const mobile = mobileToggle && mobileToggle.getClientRects().length > 0;
      const target = mobile ? mobileChild : desktopChild;
      if (!target) return;
      event.preventDefault();
      event.stopPropagation();
      if (mobile) {
        mobileToggle.scrollIntoView({block:'center'});
        if (mobileToggle.getAttribute('aria-expanded') !== 'true') mobileToggle.click();
        if (mobileChild.getAttribute('aria-expanded') !== 'true') mobileChild.click();
        const panel = document.getElementById(mobileChild.getAttribute('aria-controls'));
        const firstLink = panel && panel.querySelector('a');
        if (firstLink) firstLink.focus({preventScroll:true});
      } else {
        desktopChild.scrollIntoView({block:'center'});
        desktopChild.focus({preventScroll:true});
        setTimeout(() => {
          if (desktopChild.getAttribute('aria-expanded') !== 'true') desktopChild.click();
        }, 160);
      }
    }
    const arrow = event.target.closest('[data-review-step]');
    if (arrow) {
      const track = document.getElementById(arrow.getAttribute('aria-controls'));
      const card = track && track.querySelector('.dh-review-card');
      if (card) track.scrollBy({left:Number(arrow.dataset.reviewStep) * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).columnGap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
  });
})();
